import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic , clientPublicService } from 'helper/axios'

export const getCompanyReport = async ({ token, pathURL }) => {
  try {
    return await clientPublic
      .get(`${pathURL}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getCompanyReportV2 = async ({ token, pathURL }) => {
  try {
    const response = await clientPublicService.get(`${pathURL}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return {
      status: response.status,
      data: response.data?.result,
      error: false,
    }
  } catch (error) {
    const { response } = error || {}
    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }
    return {
      status: response?.data?.status || response?.status,
      data: [],
      error: true,
    }
  }
}

